import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDiamond(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="M1.38 4.538 7.647 1.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L1.13 5.597a.733.733 0 0 1 .25-1.059"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDiamond);
export default ForwardRef;
